import ColumnDateSelect, {
  ColumnTextCell,
} from "components/WPReactTable/components/ColumnDateSelect";
import ColumnMembers from "components/WPReactTable/components/ColumnMembers";
import ColumnNumber from "components/WPReactTable/components/ColumnNumber";
import ColumnOptions from "components/WPReactTable/components/ColumnOptions";
import ColumnStatusTask, {
  TASK_STATUS,
} from "components/WPReactTable/components/ColumnStatusTask";
import React, { useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { COLUMNS_TASK_TABLE } from "../constant/Columns";
import useDrawFocusBorder from "hooks/useDrawFocusBorder";
import { Box } from "@mui/material";
import DateRangeIcon from "@mui/icons-material/DateRange";

export const convertFieldsToTable = (
  data,
  onOpenEditColumnModal,
  handleReload = () => {},
  canEdit
) => {
  const result = [];

  data.forEach((item) => {
    if (
      item.id !== "pfd-name" &&
      item.id !== "name" &&
      item.id !== "add-column" &&
      item.is_show
    ) {
      result.push({
        ...item,
        minWidth: 150,
        maxWidth: 480,
        Header: (props) => {
          return <RenderHeader name={item.name} {...props} />;
        },
        // render ô của bảng
        Cell: (props) => {
          console.log(item, "item cell");
          const Cell = (
            <CellRender
              idType={item.id}
              nameType={item.name}
              optionsType={item.options}
              dataType={item.data_type}
              onOpenEditColumnModal={onOpenEditColumnModal}
              handleReload={handleReload}
              dataGroup={props?.data}
              canEdit={canEdit}
              {...item}
              {...props}
            />
          );
          if (
            (item.data_type === 6 ||
              item.id === "pfd-time-end" ||
              item.id === "pfd-time-start") &&
            props.rowAdd !== true &&
            props.title !== true
          )
            return (
              <Box
                sx={{
                  width: "100%",
                  height: "100%",
                  display: "flex",
                  alignItems: "center",
                  "&:hover": {
                    justifyContent: "center",
                  },
                  "&:hover #date-icon": {
                    display: "block",
                  },
                  "& #date-icon": {
                    display: "none",
                  },
                  "& #date-value": {
                    display: "block",
                  },
                  "&:hover #date-value": {
                    display: "none",
                  },
                }}
              >
                <DateRangeIcon
                  id="date-icon"
                  sx={{
                    width: "0.7em",
                    height: "0.7em",
                    color: "rgb(191 191 191)",
                    padding: "4px",
                    borderRadius: "50%",
                    border: "1px dashed rgb(191 191 191)",
                  }}
                />
                <div id="date-value">{Cell}</div>
              </Box>
            );
          return Cell;
        },
      });
    }
  });

  const colName = data.find((item) => item.id === "pfd-name");
  let pfdName = [];
  if (colName) {
    pfdName = [
      {
        ...colName,
        ...COLUMNS_TASK_TABLE[0],
      },
    ];
  } else {
    pfdName = COLUMNS_TASK_TABLE[0];
  }
  const finalColumns = canEdit
    ? [...pfdName, ...result, COLUMNS_TASK_TABLE[COLUMNS_TASK_TABLE.length - 1]]
    : [...pfdName, ...result];

  return finalColumns;
};

const RenderHeader = ({ name, ...props }) => {
  const { t } = useTranslation();
  return t(name);
};

const CellRender = ({
  dataType,
  idType,
  nameType,
  optionsType = [],
  row,
  onOpenEditColumnModal = () => {},
  handleReload = () => {},
  dataGroup,
  canEdit = true,
  decimal,
  ...props
}) => {
  const taskId = row?.original?.id;
  const data = row?.original?.data?.[props.column.id] || {};
  const statusCode = row?.original?.status_code;
  const ref = useRef(null);
  const [anchorEl, setAnchorEl] = useState(null);
  useDrawFocusBorder(anchorEl);
  if (!data) return null;
  if (row.depth === 0) return null;

  const shouldDisableNumberCol = () => {
    return (
      props?.column?.id === "pfd-complete" && statusCode === TASK_STATUS.PAUSED
    );
  };

  // eslint-disable-next-line default-case
  switch (idType) {
    case "pfd-priority":
      return (
        <ColumnOptions
          taskId={taskId}
          idType={idType}
          nameType={nameType}
          dataType={dataType}
          isDisplayEditField={false}
          isRenderNullField={false}
          optionsType={[
            { id: 2, _id: 2, name: "Thấp", value: 2, color: "#03C30B" },
            { id: 1, _id: 1, name: "Trung bình", value: 1, color: "#FF9800" },
            { id: 0, _id: 0, name: "Cao", value: 0, color: "#ff0000" },
          ]}
          isDisplay
          onEdit={onOpenEditColumnModal}
          handleReload={handleReload}
          canEdit={canEdit}
          {...data}
        />
      );
    case "pfd-member":
      return (
        <ColumnMembers
          value={data.value}
          taskId={taskId}
          dataCell={data}
          isGetDataUser
          canEdit={canEdit}
        />
      );
    case "pfd-time-start":
    case "pfd-time-end":
      return (
        <ColumnDateSelect
          value={data.value}
          taskId={taskId}
          dataCell={row?.original}
          handleReload={handleReload}
          canEdit={canEdit}
        />
      );
    case "pfd-status":
      return (
        <ColumnStatusTask
          statusCode={data.option_value}
          fieldLabel={data.field_label}
          taskId={taskId}
          complete={row.original.complete}
          handleReload={handleReload}
          canEdit={canEdit}
        />
      );
  }

  // eslint-disable-next-line default-case
  switch (dataType) {
    case 2:
      return (
        <ColumnNumber
          taskId={taskId}
          idType={idType}
          dataType={dataType}
          valueOriginal={data?.value_original}
          handleReload={handleReload}
          disabled={shouldDisableNumberCol() || !canEdit}
          canEdit={canEdit}
          {...(props?.column || {})}
          {...data}
        />
      );
    case 1:
      return (
        <ColumnTextCell
          value={data.value}
          value_original={data.value_original}
          taskId={taskId}
          idType={idType}
          dataCell={row?.original}
          handleReload={handleReload}
          canEdit={canEdit}
          isDefault={false}
        />
      );
    case 6:
      return (
        <ColumnDateSelect
          value={data.value}
          value_original={data.value_original}
          taskId={taskId}
          idType={idType}
          dataCell={row?.original}
          handleReload={handleReload}
          canEdit={canEdit}
          isDefault={false}
        />
      );
    case 3:
      return (
        <ColumnOptions
          taskId={taskId}
          idType={idType}
          nameType={nameType}
          dataType={dataType}
          optionsType={optionsType}
          onEdit={onOpenEditColumnModal}
          handleReload={handleReload}
          canEdit={canEdit}
          {...data}
        />
      );
  }

  const handleClickCell = (event) => {
    setAnchorEl(ref.current?.parentElement);
  };

  return (
    <div ref={ref} onClick={handleClickCell}>
      {data?.value} {props?.column?.format}
    </div>
  );
};
